import { Metric } from "@webapp/okrs/metrics/models/metric.models";
import { PiTrackingFlowNameEnum } from "@webapp/platform-intelligence/shared/utils/pi-tracking";

export type MetricPredictedField = "target" | "targetOperator" | "format" | "initialValue";
export const MetricPredictedFields: MetricPredictedField[] = ["target", "targetOperator", "format", "initialValue"];

export interface MetricFormParams {
  planningSessionId: string;
  metricId: string;
  metric?: Metric;
  id: string;
  flowName: PiTrackingFlowNameEnum;
}

export enum MetricManualTypeEnum {
  DOUBLE = "double",
  BOOLEAN = "boolean",
  EMPTY = "",
}

export type FocusField = "shouldFocusTitleInput" | "shouldFocusDescriptionInput" | null;

export type PiSuggestionsType = Partial<Pick<Metric, "name" | "description" | "initialValue" | "target" | "targetOperator" | "format">>;
